import { Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrentUserService } from '../../shared/CurrentUser.service';
import { map } from 'rxjs';
import { GetRoleName } from '../../shared/enums/AppRoles';
import { ApiService } from '../../shared/ApiService';
import { Country } from '../../shared/interfaces/Country';
import { CommonModule } from '@angular/common';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ProfileComponent implements OnInit {
  private http = inject(HttpClient);
  private userService = inject(CurrentUserService);
  private apiService = inject(ApiService);

  protected profile!: ProfileType;
  protected tokenRoleClaims: string[];
  protected roles: string[];
  protected tokenIssuedAt: Date;
  protected tokenValidEnd: Date;
  protected tokenValidStart: Date;
  protected protectedApiResponse: string = "Loading...";
  protected adminCountries: Country[];

  ngOnInit() {
    this.getProfile();
    const user = this.userService.GetRawUser();
    const claims = user.idTokenClaims;
    this.tokenRoleClaims = claims.roles;

    this.userService.GetAppRoles().pipe(map((roles) => roles.map(GetRoleName))).subscribe((roles) => {
      this.roles = roles;
    });

    this.tokenIssuedAt = claims.iat == null ? null : new Date(claims.iat * 1000);
    this.tokenValidEnd = claims.exp == null ? null : new Date(claims.exp * 1000);
    this.tokenValidStart = claims.nbf == null ? null : new Date(claims.nbf * 1000);

    this.testApi();
    this.populateCountryAdminList();
  }

  private testApi() {
    this.apiService.GET<any>("api/v1/app/protected-api-heartbeat")
      .subscribe({
        next: (result) => this.protectedApiResponse = result.msg,
        error: () => this.protectedApiResponse = "Error calling API. Please check logs"
      });
  }

  private populateCountryAdminList() {
    this.apiService.GET<Country[]>("api/v1/countries").subscribe((countries) => {
      this.userService.GetPaymentAdminCountries().subscribe((userCountries) => {
        this.adminCountries = countries.filter((c) => userCountries.indexOf(c.CountryId) >= 0);
      });
    });
  }

  private getProfile() {
    this.http.get(GRAPH_ENDPOINT).subscribe((profile) => this.profile = profile);
  }
}
